/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import RelationshipWidgetContextMenu from './RelationshipWidgetContextMenu';
import RelationshipVisView from './RelationshipVisView';
import RelationshipTooltip from './RelationshipTooltip';
import PropTypes from 'util/PropTypes';

class RelationshipViewWrapper extends Component {

	constructor(props) {
		super(props);
	}

	componentWillUnmount(){
		this.props.startingPointsVM.relationship.cleanup();
	}

	render() {
		return (
			<div className="relationshipViewWrapper">
				<RelationshipWidgetContextMenu module={this.props.module} startingPointsVM={this.props.startingPointsVM} />
				<RelationshipVisView relationship={this.props.startingPointsVM.relationship} services={this.props.services} fields={this.props.fields}/>
				<RelationshipTooltip model={this.props.startingPointsVM.relationship.tooltip} module={this.props.module} shouldUseDisambiguatedPaths={this.props.shouldUseDisambiguatedPaths } />
			</div>
		);
	}
}
RelationshipViewWrapper.propTypes = {
	module: PropTypes.observableObject.isRequired,
	startingPointsVM: PropTypes.object.isRequired,
	services: PropTypes.object,
	fields: PropTypes.object,
	shouldUseDisambiguatedPaths:PropTypes.bool
};

export default RelationshipViewWrapper;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipViewWrapper.js